import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Button, ClickAwayListener, CircularProgress, Tooltip, Typography } from '@mui/material'
import { Delete } from '@mui/icons-material'


function DeleteButton({ className, deleteAction, text, sx }) {

  const [activated, setActivated] = useState(false)
  const [submitted, setSubmitted] = useState(false)

  const action = () => {
    setSubmitted(true)
     
    deleteAction().then(() => {
      setActivated(false)
      setSubmitted(false)
    })
  }

  return activated
    ? <ClickAwayListener onClickAway={() => setActivated(false)}>
      {submitted
        ? <CircularProgress color='inherit' size='1.5rem' />
        : <Button className={className} onClick={action} sx={{ minWidth: '40px', ...sx }}>Supprimer ?</Button>
      }
    </ClickAwayListener>
    : <Tooltip title='Supprimer'>
      <Button className={className} onClick={() => setActivated(true)} sx={{ minWidth: '40px', ...sx }}>
        {text
          ? <Typography component='span' color='error.main' >{text}</Typography>
          : <Delete />
        }
      </Button>
    </Tooltip>
}

DeleteButton.propTypes = {
  className: PropTypes.string,
  deleteAction: PropTypes.func.isRequired,
  text: PropTypes.string,
  sx: PropTypes.object,
}

export default DeleteButton
